import logo from './logo.svg';
import Countdown from './components/Countdown/';
import ScentSelector from './components/ScentSelector/';
import DeliveryCountdown from './components/DeliveryCountdown/';
import Carousel from './components/Carousel/';

import './App.css';
// import { GrowlScene } from '@crystallize/react-growl';
import { useEffect, useState } from 'react';

// import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  const [amountToSelect, setAmountToSelect] = useState(0);
  const [productTypes, setProductTypes] = useState([]);
  const [size, setSize] = useState(['Standard (50g)']);
  const countdownWrapper = document.querySelector(`#countdown-wrapper`);
  const carouselWrapper = document.querySelector(`.carousel-wrapper`);

  const deliveryCountdownWrapper = document.querySelector(
    `.delivery-countdown-wrapper`
  );

  useEffect(() => {
    const scentSelectorWrapper = document.querySelector(
      `.scents-selector-wrapper`
    );

    if (scentSelectorWrapper?.dataset?.scentsRequired) {
      if (scentSelectorWrapper?.dataset?.scentsRequired.includes(',')) {
        setAmountToSelect(
          scentSelectorWrapper?.dataset?.scentsRequired.split(',')
        );
      } else {
        setAmountToSelect([scentSelectorWrapper?.dataset?.scentsRequired]);
      }
    }

    if (scentSelectorWrapper?.dataset?.bundleSize) {
      if (scentSelectorWrapper?.dataset?.bundleSize.includes(',')) {
        setSize(scentSelectorWrapper?.dataset?.bundleSize.split(','));
      } else {
        setSize([scentSelectorWrapper?.dataset?.bundleSize]);
      }
    }

    if (scentSelectorWrapper?.dataset?.productType) {
      if (scentSelectorWrapper?.dataset?.productType.includes(',')) {
        setProductTypes(scentSelectorWrapper?.dataset?.productType.split(','));
      } else {
        setProductTypes([scentSelectorWrapper?.dataset?.productType]);
      }
    }
  }, []);

  const getProducts = (type) => {
    if (!type) {
      return false;
    }
    if (type.includes('Wax Melt')) {
      return global.waxScents || {};
    }
    if (type.includes('Fragrance Oil')) {
      return global.fragranceOils || {};
    }

    if (type.includes('Room Spray')) {
      return global.roomSprays || {};
    }

    return {};
  };

  return (
    <div className="App">
      {amountToSelect.length > 0 && (
        <ScentSelector
          amountToSelect={amountToSelect}
          sizes={size}
          product={global.product}
          productTypes={productTypes}
          getProducts={getProducts}
          selector={document.querySelector(`.scents-selector-wrapper`)}
        />
      )}

      {countdownWrapper && countdownWrapper.dataset.countdownEndDate && (
        <Countdown
          title={countdownWrapper.dataset.countdownTitle}
          endDate={countdownWrapper.dataset.countdownEndDate}
          selector={countdownWrapper}
        />
      )}

      {deliveryCountdownWrapper && (
        <DeliveryCountdown selector={deliveryCountdownWrapper} />
      )}

      {carouselWrapper && carouselWrapper.dataset.slideId && (
        <Carousel
          slideId={carouselWrapper.dataset.slideId}
          selector={carouselWrapper}
        />
      )}
    </div>
  );
}

export default App;
